module.exports = __webpack_public_path__ + "static/media/labResultsIconColor.1e232ad7.png";